<script lang="ts" setup>
import { ref, watch } from 'vue'
import { Icon } from '@iconify/vue'

import Menu from 'primevue/menu'
import Button from 'primevue/button'
import Checkbox from 'primevue/checkbox'

interface FilterOption {
  value: string
  label: string
  id: string
}

interface Props {
  filterOptions?: FilterOption[]
  filterTitle?: string
}

const props = withDefaults(defineProps<Props>(), {
  filterOptions: () => [
    { value: 'all', label: 'All', id: 'status-all' },
    { value: 'active', label: 'Active', id: 'status-active' },
    { value: 'inactive', label: 'Inactive', id: 'status-inactive' }
  ],
  filterTitle: 'Filter Status'
})

const menu = ref()
const status = ref<string[]>([])

const emit = defineEmits<{
  filterChange: [filters: string[]]
}>()

const clearStatus = () => {
  status.value = []
}

const toggle = (event: Event) => {
  menu.value.toggle(event)
}

const applyFilter = () => {
  emit('filterChange', status.value)
  menu.value.hide()
}

watch(status, (newStatus) => {
  emit('filterChange', newStatus)
}, { deep: true })
</script>

<template>
  <div>
    <Button
        type="button"
        @click="toggle"
        outlined
        severity="secondary"
        aria-haspopup="true"
        aria-controls="overlay_menu"
        class="gap-x-2"
    >
      <span class="border-l pl-1.5">Filter </span>
      <Icon icon="mage:filter" class="text-xl" />
      <span v-if="status.length > 0" class="bg-primary-500 text-white rounded-full px-2 py-0.5 text-xs ml-1">
        {{ status.length }}
      </span>
    </Button>

    <Menu ref="menu" id="overlay_menu" popup class="!pb-0">
      <template #start>
        <div
            class="p-3 border-b border-neutral-200 bg-neutral-100 flex items-center justify-between"
        >
          <span class="font-semibold">{{ filterTitle }}</span>
        </div>
      </template>

      <template #end>
        <ul class="flex flex-col text-[13px]">
          <li
              v-for="option in filterOptions"
              :key="option.value"
              :class="`flex align-items-center gap-x-3 p-2 px-3 ${status.includes(option.value) && 'active'}`"
          >
            <Checkbox
                :inputId="option.id"
                name="status"
                :value="option.value"
                v-model="status"
            />
            <label
                :for="option.id"
                class="font-medium translate-y-1 cursor-pointer"
            >
              {{ option.label }}
            </label>
          </li>
        </ul>
      </template>
    </Menu>
  </div>
</template>

<style></style>
